module.exports = __webpack_public_path__ + "images/a63a78e44d28769ec5e329b88e554885.jpg";